export const MapFilters = {
    REGION: "region",
    STATE: "state", 
    TYPE: "type"
  };
  
  export const ViewModes = {
    GRAPH: "graph",
    TABLE: "table"
  };
  
  export const API_ENDPOINTS = {
    MAI_KPI: '/kpi/mai',
    FG_COVERAGE: '/kpi/fgCoverage',
    MSTN: '/kpi/MstnFactoryDepot',
    PROJECTED_OR: '/kpi/projected-or',
    DISPATCH_COMPLIANCE: '/kpi/DC',
    MANPOWER_INDEX: '/kpi/MP',
    DAY_CHART: '/kpi/day-chart',
    OLA_CHART: '/kpi/ola-chart',
    EXTERNAL_DISRUPTIONS: '/kpi/ExternalDistruption',
    MAP_MARKERS: '/kpi/map_alerts',
    OSA_DATA: '/kpi/Osa',
    DR_DATA: '/kpi/DR',
    D0_DATA: '/kpi/D0',
    SALES_INDEX: '/kpi/salesIndex',
    WEEKLY_OR: '/kpi/weeklyor'
  };